import Donator from "@/hosting/public/donator.js";

export default class PublicHost {
  constructor(data, stream) {
    this.globalData = data;
    this.stream = stream;
    this.host = null;
  }
  begin() {
    this.host = new Donator(this.globalData, this.stream);
    this.host.init();
  }
  changeQuality(quality) {
    if (this.host) {
      this.host.changeQuality(quality);
    }
  }
  close(callback) {
    if (this.host) {
      this.host.close(callback);
    }
  }
}
